import {
  Badge,
  Box,
  Button,
  Container,
  HStack,
  Image,
  Progress,
  Radio,
  RadioGroup,
  Stat,
  StatArrow,
  StatHelpText,
  StatLabel,
  StatNumber,
  Text,
  VStack,
} from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import Loader from "./Loader";
import axios from "axios";
import { serverAPI } from "../index";
import { useParams } from "react-router-dom"; //used to get coin id
import ErrorComponent from "./ErrorComponent";
import Chart from "./Chart";

const CoinDetails = () => {
  const [coin, SetCoin] = useState("");
  const [loading, setLoading] = useState(true);
  const [isError, setError] = useState(false);
  const [currency, setCurrency] = useState("inr");
  const [days, setDays] = useState("24h");
  const [chartArray, setChartArray] = useState([]);

  const params = useParams();

  const currencySymbol =
    currency === "inr" ? "₹" : currency === "eur" ? "€" : "$";

  const btns = ["24h", "7d", "14d", "30d", "60d", "200d", "365d", "max"];

  const switchChartStatus = (key) => {
    switch (key) {
      case "24h":
        setDays("24h");
        setLoading(true);
        break;
      case "7d":
        setDays("7d");
        setLoading(true);
        break;
      case "14d":
        setDays("14d");
        setLoading(true);
        break;
      case "30d":
        setDays("30d");
        setLoading(true);
        break;
      case "60d":
        setDays("60d");
        setLoading(true);
        break;
      case "200d":
        setDays("200d");
        setLoading(true);
        break;
      case "365d":
        setDays("365d");
        setLoading(true);
        break;
      case "max":
        setDays("max");
        setLoading(true);
        break;
      default:
        setDays("24h");
        setLoading(true);
        break;
    }
  };

  useEffect(() => {
    const fetchCoin = async () => {
      try {
        const { data } = await axios.get(serverAPI + `/coins/${params.id}`);
        //console.log(data);
        //api of chart
        const { data: chartData } = await axios.get(
          `${serverAPI}/coins/${params.id}/market_chart?vs_currency=${currency}&days=${days}`
        );
        //console.log(chartData);
        SetCoin(data);
        setChartArray(chartData.prices); //from chart we only want prices
        setLoading(false);
      } catch (error) {
        setError(true);
        setLoading(false);
      }
    };
    fetchCoin();
  }, [params.id, currency, days]);

  if (isError) return <ErrorComponent message={"Error While Fetching Coin"} />;

  return (
    <Container maxW={"container.xl"}>
      {loading ? (
        <Loader />
      ) : (
        <>
        <RadioGroup value={currency} onChange={setCurrency} p={"8"}>
            <HStack spacing={"4"}>
              <Radio value="inr">INR</Radio>
              <Radio value="usd">USD</Radio>
              <Radio value="eur">EUR</Radio>
            </HStack>
          </RadioGroup>
          <Box width={"full"} borderWidth={1}>
            <Chart arr={chartArray} currency={currencySymbol} days={days} />
          </Box>

          {/*to select time of which we want to see chart */}
          <HStack p={"4"} wrap={"wrap"} justifyContent={"center"}>
            {btns.map((i) => (
              <Button  m={"4"} key={i} onClick={() => switchChartStatus(i)}>
                {i}
              </Button>
            ))}
          </HStack>


          <VStack spacing={"4"} p="16" justifyContent={"center"} bgColor={"blackAlpha.300"} >
            <Text fontSize={"small"} alignSelf={"center"} opacity={0.7}>
              Last Updated on:{" "}
              {Date(coin.market_data.last_updated).split("G")[0]}
              {/* .split("G") will split it in two on G and then we access only first part using 0 index */}
            </Text>
            <Image
              src={coin.image.large}
              w={"16"}
              h={"16"}
              objectFit={"contain"}
            />

            <Stat>
              <StatLabel>{coin.name}</StatLabel>
              <StatNumber>
                {currencySymbol}
                {coin.market_data.current_price[currency]}
              </StatNumber>

              <StatHelpText>
                <StatArrow
                  type={
                    coin.market_data.price_change_percentage_24h > 0
                      ? "increase"
                      : "decrease"
                  }
                />
                {coin.market_data.price_change_percentage_24h}%
              </StatHelpText>
            </Stat>

            {/*inside badge will be shown coin rank*/}
            <Badge fontSize={"2xl"} bgColor={"blackAlpha.700"} color={"white"}>
              {`#${coin.market_cap_rank}`}
            </Badge>

            <CustomBar
              high={coin.market_data.high_24h[currency]}
              low={coin.market_data.low_24h[currency]}
            />

            <Box w={"full"} p="4">
              <Item title={"Max Supply"} value={coin.market_data.max_supply} />
              <Item
                title={"Circulating Supply"}
                value={coin.market_data.circulating_supply}
              />
              <Item
                title={"Market Cap"}
                value={[currencySymbol] + coin.market_data.market_cap[currency]}
              />
              <Item
                title={"All Time Low"}
                value={[currencySymbol] + coin.market_data.atl[currency]}
              />
              <Item
                title={"All Time High"}
                value={[currencySymbol] + coin.market_data.ath[currency]}
              />
            </Box>
          </VStack>
        </>
      )}
    </Container>
  );
};

export default CoinDetails;

const CustomBar = ({ high, low }) => {
  return (
    <>
      <VStack w={"full"}>
        <Progress value={"50"} colorScheme={"teal"} w={"full"} />

        <HStack justifyContent={"space-between"} w={"full"}>
          <Badge children={low} colorScheme="red" />
          <Text fontSize={"sm"}>24H Range</Text>
          <Badge children={high} colorScheme="green" />
        </HStack>
      </VStack>
    </>
  );
};

const Item = ({ title, value }) => {
  return (
    <>
      <HStack justifyContent={"space-between"} w={"full"} my={"4"}>
        <Text fontFamily={"Bebas Neue"} letterSpacing={"widest"}>
          {/*Bebas font is form google fonts via link in index.html */}
          {title}
        </Text>
        <Text>{value}</Text>
      </HStack>
    </>
  );
};
